<template>
    <vertical-form-table v-model="form" v-bind="{ items }" @input="emit"></vertical-form-table>
</template>

<script>
import { attrs_input } from "@/assets/variables/attrs";
import { initExpoProgram } from "@/assets/variables/inits";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

const items = [
    {
        key: "subject",
        type: "text",
        term: "프로그램 제목",
        required: true,
        placeholder: "프로그램 제목을 입력하세요.",
    },
    {
        key: "summary",
        type: "text",
        term: "프로그램 한줄소개",
        required: true,
        placeholder: "프로그램 한줄소개를 입력하세요.",
    },
    {
        key: "host.name",
        type: "text",
        term: "프로그램 주관기업",
        required: true,
        placeholder: "프로그램 주관기업 명칭을 입력하세요.",
    },
    {
        key: "host.workerName",
        type: "text",
        term: "담당자",
        required: true,
        placeholder: "담당자를 입력하세요.",
    },
    {
        key: "host.phone",
        type: "phone",
        term: "연락처",
        required: true,
        placeholder: "연락처를 입력하세요.",
    },
    {
        key: "host.email",
        type: "email",
        term: "이메일",
        required: true,
        placeholder: "이메일을 입력하세요.",
    },
    {
        key: "tags",
        type: "combobox",
        term: "검색태그",
        required: true,
        multiple: true,

        chips: true,
        deletableChips: true,
        smallChips: true,
        coda: "값을 입력한 뒤 Enter 또는 Tab을 눌러야 항목이 추가됩니다.",
    },
    {
        key: "thumb",
        type: "file",
        term: "대표썸네일",
        placeholder: "파일을 첨부하세요.",
        label: "권장 해상도 : 574px * 876px",
    },
    {
        key: "image",
        type: "file",
        term: "상세이미지",
        placeholder: "파일을 첨부하세요.",
        label: "권장 해상도 : 980px * 508px",
    },
].map((item) => ({
    ...attrs_input,
    ...item,
}));

export default {
    components: {
        VerticalFormTable,
    },
    props: {
        value: { type: Object, default: initExpoProgram },
    },
    data: () => ({
        form: initExpoProgram(),

        items,
    }),
    methods: {
        sync() {
            this.form = initExpoProgram(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style>
</style>